/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { productSchema } from "./productSchema.ts";

export const productsRetrieveQueryAttachLogsSchema = z.boolean().optional().default(false).describe("Отобразить логи причин скипа элементов номенкулатуры");

export const productsRetrievePathOrgUnitIdSchema = z.uuid();

export const productsRetrievePathProductIdSchema = z.uuid();

export const productsRetrieveQueryUseHotMenuSchema = z.boolean().optional().default(true).describe("Брать продукт из hot_menu, если он там есть");

export const productsRetrieveStatus200Schema = productSchema.describe(
	"Миксин для округления полей КБЖУ до целых чисел при сериализации.\nВес и КБЖУ вне допустимых пределов заменяет на null.",
);

export const productsRetrieveResponseSchema = productsRetrieveStatus200Schema;
